import React from 'react';
import Place from './Place';
import PlaceConfigurable from './PlaceConfigurable';

/**
 * AddressField - Smart wrapper that chooses the right address component
 * 
 * This component automatically detects whether a field has custom configuration
 * and renders either PlaceConfigurable (with config) or Place (legacy/default).
 * 
 * This makes it easy to use throughout the app without conditional logic.
 */
const AddressField = (props) => {
	const {
		style,
		type_id,
		fieldConfigs,  // Array of field_config records from database
		...otherProps
	} = props;

	// Check if field has custom configuration from database
	const hasFieldConfig = fieldConfigs && fieldConfigs.length > 0;

	// Use PlaceConfigurable if field has custom configuration, otherwise use Place
	if (hasFieldConfig) {
		return (
			<PlaceConfigurable
				{...otherProps}
				type_id={type_id}
				style={style}
				fieldConfigs={fieldConfigs}
			/>
		);
	}

	// Fall back to original Place component for backward compatibility
	return (
		<Place
			{...otherProps}
			type_id={type_id}
			style={style}
		/>
	);
};

export default AddressField;


